import React from 'react'
import { useDispatch } from 'react-redux'
import http from '../../../../config/BaseUrl'

const DeleteModal = ({modalId, selectedItem, setLoadingEvent, setLoadedEvent, setLoadingContent}) => {
  
  const dispatch = useDispatch()

  const submitDataForm = () => {
    const params = {
      event_id: selectedItem.event_id,
    }
    document.getElementById(`close-${modalId}`).click();
    dispatch(setLoadingEvent(true))
    dispatch(setLoadingContent("Removing, Please Wait"))
    http.post('delete/event', params)
      .then(res => {
        if (res.data.status !== 'error') {
          dispatch(setLoadingContent("Successfully Removed."))
          dispatch(setLoadedEvent(true))
          setTimeout(() => {
          dispatch(setLoadingEvent(false))
          window.location.reload()
          }, 1000)
        }
        else{
          dispatch(setLoadingContent("Error Occured."))
          dispatch(setLoadedEvent(true))
          setTimeout(() => {
            dispatch(setLoadingEvent(false))
          }, 5000)
        }
      })
      .catch(err => {
        dispatch(setLoadingContent("Error occurred while removing."))
        dispatch(setLoadedEvent(true))
        setTimeout(() => {
          dispatch(setLoadingEvent(false))
        }, 5000)
      })
  }

  return (
    <div className="modal fade" id={modalId} tabindex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Event Remove</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-center py-5">

              <h5>Are you sure?</h5>
              <p>Deleting the event will remove all captures, data and settings related to this event.</p>
              
            </div>
            <div className="modal-footer">
              <button type="button" id={`close-${modalId}`} className="btn btn-secondary" data-dismiss="modal" aria-label="Close">Cancel</button>
              <button type="button" onClick={submitDataForm} className="btn btn-primary">Yes</button>
            </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal